import { render, staticRenderFns } from "./hubsTextFields.vue?vue&type=template&id=47e7224e&scoped=true&"
import script from "./hubsTextFields.vue?vue&type=script&lang=js&"
export * from "./hubsTextFields.vue?vue&type=script&lang=js&"
import style0 from "./hubsTextFields.vue?vue&type=style&index=0&id=47e7224e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7224e",
  null
  
)

export default component.exports